import type { FieldSelectOptions, FieldSelectValue } from "./field-select.type";

export const getFieldSelectOption = <
  Value extends FieldSelectValue,
  Data extends object,
>(
  value?: Value,
  options?: FieldSelectOptions<Value, Data>
) => {
  if (!options?.length) return undefined;

  for (const option of options) {
    if ("value" in option && option.value === value) {
      return option;
    }

    if ("options" in option) {
      const found = option.options.find((item) => item.value === value);
      if (found) return found;
    }
  }

  return undefined;
};
